export { default } from '@triptyk/ember-utils/utils/generic-diff';
